import { DataService } from 'api/DataService'

import type { TableColumnPref } from './types'

const URL = '/v1/table_preferences'

export async function saveTablePreference(
  tableId: string,
  pref: TableColumnPref
): Promise<void> {
  try {
    await DataService({
      type: 'PUT',
      url: URL,
      data: { table_preferences: { [tableId]: pref } }
    })
  } catch {
    /* best-effort: localStorage ja guardou; re-sincroniza na proxima mudanca */
  }
}

export async function deleteTablePreference(tableId: string): Promise<void> {
  try {
    await DataService({
      type: 'PUT',
      url: URL,
      data: { table_preferences: { [tableId]: null } }
    })
  } catch {
    /* best-effort */
  }
}
